import {
  EnviarMensaje,
  ENVIAR_MENSAJE,
  LeerChat,
  LeerChatReset,
  LEER_CHAT,
  LEER_CHAT_RESET,
  ListadoMensajes,
  ListadoMensajesReset,
  LISTADO_MENSAJES,
  LISTADO_MENSAJES_RESET,
  OBTENER_RESPUESTAS_PREDEFINIDAS,
  GetTotalMensajesSinLeer,
  GET_TOTAL_MENSAJES_SIN_LEER,
} from '../types/messages'

export const listadoMensajesAction = (nuevos = false): ListadoMensajes => {
  return {
    type: LISTADO_MENSAJES,
    payload: { nuevos },
  }
}

export const listadoMensajesResetAction = (): ListadoMensajesReset => {
  return {
    type: LISTADO_MENSAJES_RESET,
    payload: null,
  }
}

export const leerChatAction = (payload: LeerChat['payload']): LeerChat => {
  return {
    type: LEER_CHAT,
    payload,
  }
}

export const leerChatResetAction = (): LeerChatReset => {
  return {
    type: LEER_CHAT_RESET,
    payload: null,
  }
}

export const enviarMensajeAction = (payload: EnviarMensaje['payload']): EnviarMensaje => {
  return {
    type: ENVIAR_MENSAJE,
    payload,
  }
}

export const obtenerRespuestasPredefinidas = () => {
  return {
    type: OBTENER_RESPUESTAS_PREDEFINIDAS,
  }
}

export const getTotalMensajesSinLeer = (): GetTotalMensajesSinLeer => {
  return {
    type: GET_TOTAL_MENSAJES_SIN_LEER,
    payload: null,
  }
}
